import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    marginTop    : 20,
    marginBottom : 20,
    marginLeft   : 20,
    marginRight  : 20,
    minHeight: "100vh",
    overflow: 'scroll'
  },
  header: {
    flexDirection  : "row",
    justifyContent : "space-between",
    alignItems     : "center",
  },
  title: {
    flexDirection: "row",
  },
  info: {
    flex       : 1,
    alignItems : "center",
  },
  loading: {
    height    : "auto",
    marginTop : 200,
  },
});
